import styled from '@emotion/styled';

export const StyledEmptyPage = styled.div({
  textAlign: 'center',
  marginTop: '208px',
  pointerEvents: 'none',
  fontFamily: 'Rubik',
  fontWeight: '400',
  fontSize: '16px',
  lineHeight: '24px',
});
